export default __webpack_public_path__ + "static/media/progress-t-m.3d61f55b.svg";